import { render, staticRenderFns } from "./role-management.vue?vue&type=template&id=3f8f11d6"
import script from "./role-management.vue?vue&type=script&lang=js"
export * from "./role-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports